/** Max UTF-8 bytes for a single source string (UI + API must match). */
export const MAX_SOURCE_UTF8_BYTES = 8000;

/** Character cap for textarea (aligned with byte limit for typical Latin text). */
export const MAX_SOURCE_CHARACTERS = MAX_SOURCE_UTF8_BYTES;

export const SOURCE_WARNING_THRESHOLD = Math.floor(MAX_SOURCE_CHARACTERS * 0.9);

export function sourceUtf8ByteLength(text) {
  return new TextEncoder().encode(text).length;
}

export function isSourceOverLimit(text) {
  return sourceUtf8ByteLength(text) > MAX_SOURCE_UTF8_BYTES;
}
